declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

/**
 * Pushes a custom event to the Google Tag Manager data layer.
 * Initialises the data layer if GTM has not loaded (e.g. no GTM_KEY or blocked),
 * GTM replays queued events once it loads.
 */
export function trackEvent(
    event: string,
    params: Record<string, unknown> = {},
): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}
